// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"bb348280","433":"4704d18a","435":"c1fa5d0e","578":"67df3ea0","633":"72f01b47","648":"ccf17e3a","708":"ee2da6fe","771":"936d83b7","787":"dbe64827"}[chunkId] + ".chunk.js";
};